import { styled } from '@acko-tech/building-blocks.ui.common';

export const Container = styled.div`
    max-width: 1160px;
    margin: auto;
`;

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
    background-color: #ffffff;
    max-width: 465px;
    height: 350px;
    // Setting order for moving card to right side
    order: ${(props: any) => (props?.order === 2 ? 2 : '')};

    @media screen and (max-width: 1200px) {
        order: 2;
        max-width: unset;
        height: unset;
        margin-bottom: 20px;
    }
`;

export const Title = styled.div`
    display: flex;
    font-weight: bold;
    font-size: 22px;
    line-height: 32px;
    color: #0b0e34;
    padding-top: 20px;
    @media screen and (max-width: 780px) {
        padding-top: 0;
        font-size: 16px;
    }
`;

export const Description = styled.div`
    display: flex;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: #5d607c;
    margin-top: 20px;
    @media screen and (max-width: 780px) {
        font-size: 13px;
        margin-top: 5px;
    }
`;

export const PointsWrapper = styled.div`
    margin-top: 12px;
    padding-bottom: 20px;
`;

export const Points = styled.li`
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: #5d607c;
    margin-left: 5px;
    @media screen and (max-width: 780px) {
        font-size: 13px;
    }
`;

export const Heading = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 800;
    font-size: 26px;
    line-height: 31px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #414a53;
    @media screen and (max-width: 780px) {
        margin-top: 32px;
        margin-bottom: 20px;
        font-size: 26px;
    }
`;

export const Wrapper = styled.div`
    padding: 60px 140px;
    background-color: #f1f3f8;
    @media screen and (max-width: 780px) {
        padding: 40px 20px;
    }
`;

export const ProductsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
`;

export const ProductDetails = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;
